import dayjs from 'dayjs';
import cloneDeep from 'lodash.clonedeep';
import { mergeAndRemoveDuplicates } from './merge';
import { makePolicyDetailsFromSegments as farmMakePolicyDetailsFromSegments } from '@ourbranch/farm-utils';
import { policyType } from '@ourbranch/lookups';

// The first segment is always included regardless of `activeSegmentsOnly` and `activeOnDate`,
export function policyDetailsFromSegments(
  policy: Record<string, any>,
  {
    activeSegmentsOnly = false,
    activeOnDate = '',
    ignoreRenewalSegments = true,
    upToSegmentIndex = undefined,
    upToSegmentId = undefined,
    keepPremium = false
  } = {}
) {
  if (policy.policyType === policyType.Farm) {
    return farmMakePolicyDetailsFromSegments(<any>policy, policy.segments, {
      activeSegmentsOnly,
      activeOnDate,
      ignoreRenewalSegments,
      upToSegmentIndex,
      upToSegmentId,
      keepPremium
    });
  }

  const policyDetails = cloneDeep(policy.segments[0]);
  for (let i = 1; i < policy.segments.length; i += 1) {
    if (activeSegmentsOnly && dayjs(policy.segments[i].startDate).isAfter(dayjs())) {
      // Ignore any segments that start in the future if `activeSegmentsOnly` is true
      continue;
    }

    if (activeOnDate && dayjs(policy.segments[i].startDate).isAfter(dayjs(activeOnDate))) {
      // for claims only show policy segments that are active on date of loss
      continue;
    }

    if (ignoreRenewalSegments && dayjs(policy.segments[i].startDate).isAfter(policy.endDate)) {
      // ignore any renewal segments unless is explicitly included by upToSegmentIndex or upToSegmentId
      continue;
    }

    if (upToSegmentIndex !== undefined && i > upToSegmentIndex) {
      break;
    }

    mergeAndRemoveDuplicates(policyDetails, policy.segments[i]);

    if (upToSegmentId && policy.segments[i].segmentId === upToSegmentId) {
      break;
    }
  }

  if (policyDetails?.premium && !keepPremium) {
    // we don't want the segment details premium to override policy.premium
    // and we copy the elements here to the root of policy
    delete policyDetails.premium;
  }
  return policyDetails;
}
